import type { EmissorConfigType } from 'types';
import { env } from 'utils/env';

export const VRPAT: EmissorConfigType = {
  social: 'VR Benefícios',
  logo: `${env.REACT_APP_ASSETS_PORTAL}/vrpat/img/logo.png`,
  infoList: [
    {
      code: 'n-pat',
      text: 'N° PAT: 130385510',
      link: null,
    },
    {
      code: 'cnpj',
      text: 'CNPJ: 02.535.864/0001-33',
      link: null,
    },
    {
      code: 'politica-privacidade',
      text: `Política de Privacidade`,
      link: 'http://www.vr.com.br/portal/portal-vr/area-publica/politica-de-privacidade/',
    },
    {
      code: 'boas-praticas',
      text: 'Boas Práticas',
      link: 'https://www.vr.com.br/saiba-mais-sobre/melhores-praticas-de-seguranca.htm',
    },
  ],
  portal: {
    EC: {
      buttons: [
        {
          code: 'apple-store',
          image: `${env.REACT_APP_ASSETS_PORTAL}/vrpat/img/footer/apple-store.svg`,
          link: 'https://apps.apple.com/br/developer/vr-beneficios-e-servicos-de-processamento-ltda/id649491508',
        },
        {
          code: 'google-play',
          image: `${env.REACT_APP_ASSETS_PORTAL}/vrpat/img/footer/google-play.svg`,
          link: 'https://play.google.com/store/apps/developer?id=VR+Benef%C3%ADcios',
        },
      ],
    },
  },
  fonts: `${env.REACT_APP_ASSETS_PORTAL}/vrpat/css/fonts.min.css`,
};
